import { IMicrositeRecipientForList } from '@nkr/models/microsites/microsite-recipient-for-list';

export interface IMicrositeRecipientForListWithSelect extends IMicrositeRecipientForList {
    isSelected: boolean
}